<div class="d-flex justify-content-center align-items-center bg-light main-container">
    <div class="text-center bg-white border border-warning rounded p-5">
        <h1>404</h1>
        <h4>Oops, the page you're looking for doesn't exist.</h4>
    </div>
</div>